import { Check } from 'lucide-react'
import { useState } from 'react'

interface ImageGridItemProps {
    imageUrl: string
    isSelected: boolean
    onSelect: () => void
    alt?: string
}

export function ImageGridItem({ imageUrl, isSelected, onSelect, alt = 'Avatar' }: ImageGridItemProps) {
    const [isLoaded, setIsLoaded] = useState(false)
    const [hasError, setHasError] = useState(false)

    return (
        <button
            onClick={onSelect}
            className={`
                relative aspect-square rounded-xl overflow-hidden
                transition-all duration-200 ease-out
                hover:scale-105 hover:shadow-lg
                focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2
                ${isSelected ? 'ring-4 ring-blue-500 scale-105' : 'ring-1 ring-gray-200 dark:ring-gray-700'}
                ${!isLoaded && !hasError ? 'bg-gray-200 dark:bg-gray-800 animate-pulse' : ''}
            `}
            aria-label={`Selecionar ${alt}`}
            aria-pressed={isSelected}
        >
            {/* Image */}
            <img
                src={imageUrl}
                alt={alt}
                loading="lazy"
                onLoad={() => setIsLoaded(true)}
                onError={() => {
                    setHasError(true)
                    setIsLoaded(true)
                }}
                className={`
                    w-full h-full object-cover
                    transition-opacity duration-300
                    ${isLoaded ? 'opacity-100' : 'opacity-0'}
                `}
            />

            {/* Error state */}
            {hasError && (
                <div className="absolute inset-0 flex items-center justify-center bg-gray-100 dark:bg-gray-800">
                    <span className="text-xs text-gray-400">Erro ao carregar</span>
                </div>
            )}

            {/* Selection overlay */}
            {isSelected && (
                <div className="absolute inset-0 bg-blue-500/20 backdrop-blur-[1px] flex items-center justify-center">
                    <div className="w-10 h-10 rounded-full bg-blue-500 flex items-center justify-center shadow-lg">
                        <Check className="w-6 h-6 text-white" strokeWidth={3} />
                    </div>
                </div>
            )}

            {/* Hover overlay */}
            <div className="absolute inset-0 bg-black/0 hover:bg-black/10 transition-colors duration-200" />
        </button>
    )
}
